import styled from "@emotion/styled";
import { Toolbar } from "@mui/material";

export const ToolbarThinWrapper = styled(Toolbar)({
  "@media (min-width: 600px)": {
    height: 10,
    minHeight: 10,
  },
  "@media (min-width: 0px)": {
    height: 10,
    minHeight: 10,
  },
});
